import {
    Box,
    Skeleton,
    Card,
    CardContent,
    Grid,
    Typography,
    Stack,
} from '@mui/material';

const EditContactSkeleton = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Card>
                <CardContent>
                    {/* Section: Contact Details */}
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        <Skeleton variant="text" width={200} />
                    </Typography>

                    {/* Avatar and Contact Information */}
                    <Grid container spacing={2} sx={{ mb: 4 }}>
                        <Grid item xs={12} md={3}>
                            <Skeleton
                                variant="circular"
                                width={100}
                                height={100}
                            />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height={40}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height={40}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height={40}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton
                                        variant="text"
                                        width="100%"
                                        height={40}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Section: Communication */}
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        <Skeleton variant="text" width={200} />
                    </Typography>
                    <Grid container spacing={2} sx={{ mb: 4 }}>
                        <Grid item xs={6}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                    </Grid>

                    {/* Section: Address */}
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        <Skeleton variant="text" width={200} />
                    </Typography>
                    <Grid container spacing={2} sx={{ mb: 4 }}>
                        <Grid item xs={12}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={3}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={3}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={3}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={3}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton variant="text" width="100%" height={40} />
                        </Grid>
                    </Grid>

                    {/* Section: More Details */}
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        <Skeleton variant="text" width={200} />
                    </Typography>
                    <Skeleton variant="text" width="100%" height={80} />

                    {/* Save Buttons */}
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        sx={{ mt: 4 }}
                    >
                        <Skeleton
                            variant="rectangular"
                            width={100}
                            height={40}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={120}
                            height={40}
                        />
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
};

export default EditContactSkeleton;
